import { apiGet } from './client';

/** One aggregated cash-in row: a payment method with its paid totals. */
export type SummaryCashInRow = {
  /** PAYOK payment-method code, e.g. QRIS / BCAVA / DANAWALLET. */
  method: string;
  trxCount: number;
  grossIncome: number;
  fee: number;
};

/** One aggregated cash-out row: a destination bank with its paid totals. */
export type SummaryCashOutRow = {
  /** Beneficiary bank name (falls back to bank code, else em dash). */
  product: string;
  trxCount: number;
  grossIncome: number;
  fee: number;
};

export type SummaryResponse = {
  /** 'merchant' = scoped to one merchant; 'platform' = cross-merchant aggregate. */
  scope: 'merchant' | 'platform';
  range: { from: string; to: string };
  totals: {
    cashIn: { amount: number; count: number };
    cashOut: { amount: number; count: number };
    /** Deposit fee + disbursement fee over the period (paid only). */
    fee: number;
  };
  cashIn: SummaryCashInRow[];
  cashOut: SummaryCashOutRow[];
};

export const summaryApi = {
  /**
   * On-screen aggregated transaction summary for a GMT+7 date range. `from`/`to`
   * are YYYY-MM-DD (default last 7 days). `merchantIds` is honoured only for
   * internal users (comma-joined on the wire) — an empty/absent list means ALL
   * merchants. External users are always pinned to their own merchant.
   */
  get: (params: { from?: string; to?: string; merchantIds?: string[] } = {}) => {
    const q = new URLSearchParams();
    if (params.from) q.set('from', params.from);
    if (params.to) q.set('to', params.to);
    if (params.merchantIds && params.merchantIds.length > 0) {
      q.set('merchantIds', params.merchantIds.join(','));
    }
    const qs = q.toString();
    return apiGet<SummaryResponse>(`/api/reports/summary${qs ? `?${qs}` : ''}`);
  },
};
